import { Component, OnInit, Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'dialog-ok',
  templateUrl: './dialog.ok.html',
  styleUrls: ['./dialog.ok.css']
})
export class DialogOk implements OnInit {
  ftitle="";
  fsubtitle="";
  ftext="";
  fvisible:boolean=true;

  @Output() click = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  @Input()
  get title(){
    return this.ftitle;
  }
  set title(v){
    this.ftitle = v;
  }

  @Input()
  get subtitle(){
    return this.fsubtitle;
  }
  set subtitle(v){
    this.fsubtitle = v;
  }

  @Input()
  get text(){
    return this.ftext;
  }
  set text(v){
    this.ftext = v;
  }

  @Input()
  get visible(){
    return this.fvisible;
  }
  set visible(v:boolean){
    this.fvisible=v;
  }

  okClick(){
    this.fvisible = false;
  }

}
